import tokens from "@teachers/design-system/tokens/dist/index.json";

export const easelColors = {
  easelCreamLight: "#fffaf5",
  easelCream: "#f9f3ec",
  easelGold100: "#fff6e0",
  easelPeriwinkle100: "#ecf0ff",
  easelPeriwinkle200: "#cfd8fb",
  easelPeriwinkle300: "#a1b1f1",
  easelPeriwinkle400: "#778cd9",
  easelPeriwinkle500: "#667cce",
  easelPeriwinkle600: "#5058b5",
  easelPeriwinkle700: "#39429b",
  easelEvergreen200: "#00d4a2",
  easelEvergreen300: "#01B48A",
  easelEvergreen400: "#21a284",
  easelEvergreen500: "#058466",
  easelEvergreen600: "#08795e",
  easelCoral100: "#ffe4e2",
  easelCoral200: "#fdaaa3",
  easelCoral300: "#ff7267",
  easelCoral400: "#fb5b4e",
  easelCoral500: "#df412b",
  easelCoral600: "#be2412",
  easelCoral700: "#a6271a",
  easelCharcoal: "#323232",
  easelSeafoam: "#a3d6d9",
  white: "#ffffff",
  almostBlack: "#222222",
  coreGray500: "#777777",
};

export const easelFontFamily = "Graphik, Helvetica Neue, Helvetica, sans-serif";

export const colors = {
  lightGreen: "#E7F8EF",
  mediumGreen: "#27AE60",
  lightBrandGreen: "#66C9AE",
  darkGreen: "#1D8270",

  brightRed: "#ED3724",
  mediumRed: "#CB2424",
  lightRed: "#F5D9D6",
  lightestRed: "#FFF1F0",
  coralRed: "#FF604F",

  darkestGray: "#333333",

  darkGray: "#4F4F4F",
  darkMediumGray: "#777777",
  mediumGray: "#828282",
  mediumLightGray: "#979797",
  lightGray: "#E0E0E0",
  lighterGray: "#E9E9E9",
  lightestGray: "#EFEFEF",

  mediumBlue: "#2D9CDB",
  lightBlue: "#EEF6FF",
};

// https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4
const opacitySuffixes = {
  5: "0D",
  9: "17",
  15: "26",
  25: "40",
  95: "F2",
  91: "E8",
};

export const getColorWithOpacity = (
  colorName: keyof typeof easelColors,
  percent: keyof typeof opacitySuffixes
): string => {
  const color = easelColors[colorName];
  const opacitySuffix = opacitySuffixes[percent];

  if (color === undefined || opacitySuffix === undefined) {
    return "";
  }

  return `${color}${opacitySuffix}`;
};

export const designTokens = tokens;
